import { Chip } from "@mui/material";
import { getEnvironment, ENV_CONFIG } from "@/utils/environment";

export const EnvironmentBadge = () => {
  const env = getEnvironment();

  if (env === "production") return null;

  const config = ENV_CONFIG[env];

  return <Chip label={config.label} color={config.color} size="small" sx={{ fontWeight: "bold" }} />;
};
